import { CommonError } from '../../../types';
import { FETCH_EVENTS_FAILURE, FETCH_EVENTS_REQUEST, FETCH_EVENTS_SUCCESS } from './constants';
import { EventsData, payloadData } from './types';

export interface FetchEventsRequestAction {
    type: typeof FETCH_EVENTS_REQUEST;
    payload: payloadData;
}

export interface FetchEventsSuccessAction {
    type: typeof FETCH_EVENTS_SUCCESS;
    payload: EventsData[];
}

export interface FetchEventsFailureAction {
    type: typeof FETCH_EVENTS_FAILURE;
    payload: CommonError;
}

export type EventsActions = FetchEventsRequestAction | FetchEventsSuccessAction | FetchEventsFailureAction;

export const fetchEventsRequest = (payload: payloadData): FetchEventsRequestAction => ({
    type: FETCH_EVENTS_REQUEST,
    payload,
});

export const fetchEventsSuccess = (newsDatas: EventsData[]): FetchEventsSuccessAction => ({
    type: FETCH_EVENTS_SUCCESS,
    payload: newsDatas,
});

export const fetchEventsFailure = (error: CommonError): FetchEventsFailureAction => ({
    type: FETCH_EVENTS_FAILURE,
    payload: error,
});
